<template>
  <layout-broker :name="layout">
    <RouterView />
  </layout-broker>
</template>
<script>
import { RouterView } from 'vue-router'
import LayoutBroker from '@/layouts/broker.vue'
import storage from '@/plugins/storage'
export default {
  name: 'app',
  components: {
    LayoutBroker,
    RouterView
  },
  data() {
    return {
      token: storage.session.getItem('auth/token')
    }
  },
  mounted() {
    let version = window.version ? window.version : ''
    let pathname = window.location.pathname;
    console.log('Version:', version)
    let url = window.location.href
    let lastSegment = url.substring(url.lastIndexOf('/') + 1)
    if ((lastSegment !== 'login' || lastSegment === ' ') && pathname !== '/video' ) {
      if (!this.token) {
        window.location.assign('/login')
      }
    }
  },
  computed: {
    layout() {
      return this.$route.meta && this.$route.meta.layout
        ? this.$route.meta.layout
        : 'no-nav'
    }
  }
}

</script>
<style lang="scss">
@import '../src/assets/sass/custom.scss';
</style>
